import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { getUserEmail } from '../auth';

/**
 * DashboardForm - starts a dashboard lookup for the signed-in user.
 *
 * The dashboard tab only renders for authenticated users (see App.js), and the
 * app keys every record on the Cognito email (userId === email), so there is no
 * userId to ask for — it comes from the ID token.
 *
 * @param {Object} props
 * @param {Function} props.onSubmit - onSubmit(userId)
 * @param {boolean} props.loading
 */
function DashboardForm({ onSubmit, loading }) {
  const email = getUserEmail();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      onSubmit(email);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2 }}>
      <Typography color="text.secondary">
        Account: <strong data-testid="dashboard-form-identity">{email}</strong>
      </Typography>
      <Button type="submit" disabled={loading || !email}>
        {loading ? 'Loading…' : 'Generate AI Dashboard'}
      </Button>
    </Box>
  );
}

export default DashboardForm;
